export default __webpack_public_path__ + "static/media/4s.9db64d00.svg";